// @flow

import React from 'react';

import {
  getFormattedDateAndTime,
  getRetailTableCellObject,
  trackCN
} from '../../../../services/helpers';
import { RenderTableActionButtons } from '../../../commons/tableActionButton/tableActionButton';
import { zoomTableActionsConfig } from '../../../commons/zoomTable/zoomTableConfig';
import { BlockCNStatus } from '../../../helper/Constants';

const blockCnIcon = require('../../../../assets/images/block_cn_icn.svg');

export const headers = [
  { label: 'CN Number', key: 'cnote' },
  { label: 'Client Code', key: 'clientCode' },
  { label: 'Client Name', key: 'clientName' },
  { label: 'Action Taken by', key: 'lastUpdatedByUser.name' },
  { label: 'Date & Time', key: 'lastUpdatedAt' },
  { label: 'Reason', key: 'reason' },
  { label: 'Status', key: 'isActive' }
];

export const blockCNButtonConfig = {
  buttons: [
    {
      // delete button
      iconRef: blockCnIcon,
      onClick: rowData => {
        zoomTableActionsConfig.BLOCK_CN.actions.deleteCellPrefix(rowData);
      },
      style: {
        width: '20%',
        height: '50%',
        margin: '5%'
      },
      hide: rowData => !rowData.isActive
    }
  ]
};

export const blockCNDashboardConfig = {
  // config for internal users
  columns: [
    {
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      Header: headers[0].label,
      sortable: false,
      key: headers[0].key,
      Cell: (row: Object) => (
        <div className="l-row a-center">
          {getRetailTableCellObject(
            row.original && row.original.cnote,
            '',
            row.original,
            trackCN,
            'cn-highlight'
          )}
        </div>
      )
    },
    {
      Header: headers[1].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[1].key,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original && row.original.clientCode,
          '',
          row.original
        )
    },
    {
      Header: headers[2].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: true,
      key: headers[2].key,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original && row.original && row.original.clientName,
          '',
          row.original
        )
    },
    {
      Header: headers[3].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: true,
      key: headers[3].key,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original &&
            row.original.lastUpdatedByUser &&
            row.original.lastUpdatedByUser.name,
          '',
          row.original
        )
    },
    {
      Header: headers[4].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[4].key,
      formatter: (row: Object) =>
        row && row.lastUpdatedAt && getFormattedDateAndTime(row.lastUpdatedAt),
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original &&
            row.original.lastUpdatedAt &&
            getFormattedDateAndTime(row.original.lastUpdatedAt),
          '',
          row.original
        )
    },
    {
      Header: headers[5].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[5].key,
      Cell: (row: Object) =>
        getRetailTableCellObject(row.original.reason, '', row.original)
    },
    {
      Header: headers[6].label,
      headerClassName: 'flex-11 zt-custom-th',
      className: 'zt-custom-td flex-11',
      sortable: false,
      key: headers[6].key,
      formatter: (row: Object) =>
        row && row.isActive ? BlockCNStatus.BLOCKED : BlockCNStatus.UNBLOCKED,
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original && row.original.isActive
            ? BlockCNStatus.BLOCKED
            : BlockCNStatus.UNBLOCKED,
          '',
          row.original
        )
    },
    {
      Header: 'Action',
      headerClassName: 'flex-10',
      className: 'flex-10',
      Cell: (row: Object) => (
        <RenderTableActionButtons
          buttonConfig={blockCNButtonConfig.buttons}
          rowData={row.original || {}}
        />
      )
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: "No CN's to Track",
  minRows: 0,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: 'calc(100vh - 18rem)' }
};

export const blockCNDashboardTableActionConfig = {};
